import { negativeTestV2, negativeTestV3 } from '../templates/en/messages/about/negative-test';
import vaccination from '../templates/en/messages/about/vaccination';
import recovery from '../templates/en/messages/about/recovery';
import positiveTest from '../templates/en/messages/about/positive-test';
import footer from '../templates/en/footer';

const en = {
    'date': {
        'months': {
            'abbr': ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
        }
    },
    'template': { footer },
    'views': {
        'home': {
            'pageHeader': 'Get access to your Digital Covid Certificate (DCC)',
            'pageIntro': '<h2 class="screen-reader-text">Here\'s how it works</h2><p>Here\'s how it works:</p><div class="home__section"><h4>Digital Covid Certificate</h4><p>Your health and that of others is important. That is why some countries and places ask for a Covid Pass. You can request this proof if you have been fully vaccinated for more than two weeks of have been tested negative for Covid-19.</p><p>Fully vaccinated means 2 vaccinations or a positive COVID-19 test combined with one vaccination.</p></div><div class="home__section"><h4>Certificate of test or vaccination</h4><p>You can make a coronavirus pass if: <ul style="padding-left: 40px;"><li>you have been vaccinated</li><li>a test result confirms you don’t have corona</li><li>you’ve had coronavirus and are recovered</li></ul></p></div><div class="home__section"><h4>QR-code = your proof</h4><p>Curacao Health App generates a QR code with your vaccination or test result. That is your certificate. This QR code will be checked before you get access.</p></div><div class="home__section"><h4>QR-code for Curaçao, Dutch Kingdom and Europe</h4><p>You will receive one QR-code. This is for local use and travel within the Kingdom and Europe.</p></div>',
            'userConsentHeader': 'Start making a certificate on paper',
            'userConsentText': 'I have read the <a href="{host}/PrivacyStatementEN" target="_blank">privacy statement</a> and understand how Curaçao Health App processes my data.',
            'noConsentError': 'Give consent to the privacy statement first',
            'Privacystatement': 'Privacyverklaring Curaçao Health App DCC en fysiek coronabewijs',
            'internationaleQRcode': 'De internationale QR-code'
        },
        'choiceProof': {
            'pageHeader': 'Create your certificate',
            'pageIntro': '',
            'description': '',
            'choiceTestHeader': 'A test certificate',
            'choiceTestBody': 'The test proves I do not have coronavirus',
            'choiceRecoveryHeader': 'A recovery certificate',
            'choiceRecoveryBody': 'The test proves I have had coronavirus',
            'choiceAanmeldingHeader': 'Start your application process',
            'choiceAanmeldingBody': 'Click here to register',
            'choiceVaccinationHeader': 'Vaccination Certificate',
            'choiceVaccinationBody': 'I am fully vaccinated'
        },
        'choiceTestLocation': {
            'pageHeader': 'Where have you been tested?',
            'pageIntro': '<p>Indicate whether you were tested at the GGD or at a different test location.</p>',
            'choiceGGDHead': 'GGD',
            'choiceGGDBody': 'Log in with DigiD',
            'loginDigid': 'I don’t have DigiD',
            'choiceOtherLocation': 'Other test location',
            'didNotGetTestedYet': 'I have not been tested yet'
        },
        'collectVaccination': {
            'pageHeader': 'Collect vaccination',
            'pageIntro': '<p>Have you been vaccinated? Log in with DigiD. Your vaccination details will be automatically retrieved.</p><p>Questions about vaccinations? Read more on the <a href="https://www.rijksoverheid.nl/onderwerpen/coronavirus-vaccinatie" target="_blank">website of the Dutch Government</a></p>'
        },
        'collectVaccinationToken': {
            'pageHeader': 'Retrieve vaccination data',
            'pageIntro': '<p>Have you already been vaccinated? Enter your unique combination code. Your vaccination data will be automatically retrieved.</p><p>In the event you did not receive a vaccine shot, please get vaccinated first.</p>',
            'vaccinationtoken': 'Unique combination code:'
        },
        'collectTestToken': {
            'pageHeader': 'Retrieve test data',
            'pageIntro': '<p>Have you already been tested for Covid-19? Enter your retrieval code. The test location sent it to you. The details of your Covid-19 test will be retrieved automatically.</p>'
        },
        'VaccinationVerifyCodeCW': {
            'pageHeader': 'Enter Verification Code',
            'pageIntro': '<p>A verification code was sent to your selected contact method.</p><p>Enter the verification code below.</p><p>Click on the verify code button to retrieve and generate your QR-Code.</p>',
            'subtitle': 'Verification code:'
        },
        'VaccinationOverview': {
            'pageHeader': 'Your retrieved vaccinations',
            'pageIntro': '<p>You can make a QR-code of your vaccinations. This will be your certificate.</p>',
            'createTestProofButton': 'Make QR-code'
        },
        'TestOverview': {
            'pageHeader': 'Your retrieved test',
            'pageIntro': '<p>You can make a proof of your test.</p>',
            'createTestProofButton': 'Make QR-code'
        },
        'RecoveryOverview': {
            'pageHeader': 'Your retrieved recovery',
            'pageIntro': '<p>You can make a proof of your recovery.</p>',
            'createRecoveryProofButton': 'Make QR-code'
        },
        'noVaccinations': {
            'pageHeader': 'No vaccination(s) available',
            'pageIntro': '<p>Details about your vaccination are not available.</p><p>Have you been vaccinated recently? It might take a little while before your details are available.</p><p>Your general practitioner might not be affiliated with the GGD. For more information, please go to <a href="https://www.coronacheck.nl/en/guidepost" target="_blank">CoronaCheck.nl/en/guidepost</a>.</p>'
        },
        'notPossibleVaccinations': {
            'pageHeader': 'We can’t make a certificate',
            'pageIntro': '<p>At the moment, we cannot provide proof of your vaccination. This can have different causes. For more information, please go to <a href="https://www.coronacheck.nl/en/guidepost" target="_blank">CoronaCheck.nl/en/guidepost</a>.</p>'
        },
        'vaccinationsIncomplete': {
            'pageHeader': 'We can’t make a certificate',
            'pageIntro': '<p>At this moment, we can’t make a certificate. For a Dutch certificate you need to be fully vaccinated. An international certificate can be made from July 1st.</p>'
        },
        'collectRecovery': {
            'pageHeader': 'Retrieve recovery details',
            'pageIntro': '<p>Have you had coronavirus? Then you can make a recovery certificate of the positive test result from the GGD.</p><p>Your recovery certificate will be valid 11 days after the positive test result. You also need to be symptom-free.</p>'
        },
        'provideCode': {
            'pageHeader': 'Retrieve test result',
            'pageIntro': 'Enter your retrieval code. The test location sent it to you. Or click on the link in the email you\'ll get from the test location.',
            'uniqueCode': 'Retrieval code',
            'verificationCode': 'Verification code',
            'verificationCodeDirection': 'You get a code via text or email',
            'sendAgain': 'Send again',
            'didNotGetCode': 'I don\'t have a code',
            'emptyTestCode': 'Retrieval code not entered',
            'invalidTestCode': 'Invalid retrieval code',
            'invalidVerificationCode': 'Invalid verification code',
            'emptyVerificationCode': 'Verification code not entered',
            'sendCode': 'Send code'
        },
        'NegativeTestOverview': {
            'pageHeader': 'Check your test result',
            'pageIntro': '<p>This test result is retrieved from the test location.</p><p>Is the below correct? Then you can convert the negative test result into a QR-code. This is your test certificate.</p>',
            'createTestProofButton': 'Make QR-code',
            'retrievedTestResult': 'Retrieved test result'
        },
        'testResultPending': {
            'pageHeader': 'Test result not yet known',
            'pageIntro': 'Please try again later.<br>If you have any questions, contact your test location.'
        },
        'testResultNone': {
            'pageHeader': 'No negative test result available',
            'pageIntro': 'There is no negative test result available.'
        },
        'recoveryOverview': {
            'pageHeader': 'Your retrieved positive test result',
            'pageIntro': '<p>Are your details correct? Then you can turn your positive test result into a QR-code. This is your certificate.</p>'
        },
        'recoveryNone': {
            'pageHeader': 'No positive test result available',
            'pageIntro': '<p>There is no positive test result available.<p><p>Got tested recently? It can take a few hours until your details are available. Try again later.</p><p>Have you been tested more than 180 days ago? Then your test result is no longer valid. In this case, you cannot create a recovery certificate.</p>'
        },
        'recoveryNotPossible': {
            'pageHeader': 'We can\'t make a certificate',
            'pageIntro': 'At this moment, we can\'t make a certificate from your positive test result. This can have various causes. Read more <a href="https://coronacheck.nl/en/wegwijzer.html" target="_blank">here</a>.'
        },
        'print': {
            'openPDF': 'Open PDF'
        },
        'printNegativeTest': {
            'both': {
                'pageHeader': 'Print your certificates',
                'pageIntro': '<p><b>Your certificates</b><br>You’ve made a test certificate, in the form of  a QR-code. You’ve got a code for the Netherlands and one for other countries.</p><p><b>Information in the QR</b><br><a href="https://coronacheck.nl/en/faq/1-6-welke-informatie-staat-in-mijn-qr-code/" target="_blank">Read here</a> which information the QR-code contains</p><p><b>What now?</b><br>Print the PDF and bring it with you to the location or activity you’re visiting. Or to the country you’re travelling to.</p>'
            },
            'domestic': {
                'pageHeader': 'Your test certificate',
                'pageIntro': 'You\'ve made a test certificate,  in the form of a QR-code. Read which information the QR-code contains. Print the PDF and take it with you.'
            }
        },
        'printVaccination': {
            'both': {
                'pageHeader': 'Print your certificates',
                'pageIntro': '<p><b>Your certificates</b><br>You’ve made a vaccination certificate, in the form of a QR-code. You’ve got a code for the Netherlands and one for other countries.</p><p><b>Information in the QR</b><br><a href="https://coronacheck.nl/en/faq/1-6-welke-informatie-staat-in-mijn-qr-code/" target="_blank">Read here</a> which information the QR-code contains</p><p><b>What now?</b><br>Print the PDF and bring it with you to the location or activity you’re visiting. Or to the country you’re travelling to.</p><p>Please note: this paper certificate is valid for 1 year. After that, you can make a new paper certificate of your vaccination. </p>'
            },
            'european': {
                'pageHeader': 'Print your vaccination certificate',
                'pageIntro': '<h3>Your certificate</h3><p>You’ve made a vaccination certificate in the form of a QR-code. You have a QR-code for the Netherlands and one for other countries.</p><h3>Information in the QR</h3><p><a href="https://coronacheck.nl/nl/faq/1-6-welke-informatie-staat-in-mijn-qr-code/" target="_blank">Read what is in the QR-codes</a>.</p><h3>What now?</h3><p>Print the PDF and take your print to the location or activity you’re visiting. Or to the country you’re travelling to.</p> '
            },
            'local': {
                'pageHeader': 'Download/Print your vaccination certificate',
                'pageIntro': '<p><b>Your certificate</b><br>You have created a local vaccination certificate, in the form of a QR-code. This is valid locally, within the Kingdom and in Europe.</p><p>It is not a passport, but only proof of your vaccination status.</P><p><b>Information in the QR</b><br>To read what is in the QR-code, <a href="{host}/InternationalQRCodeEN" target="_blank">click here</a>.</p><p><b>How do I use it</b><br>Download/Print the PDF and take it with you to the location/event you are visiting. Or to the country you are traveling to.</p><p>Note: This certificate is valid for 1 year after you have generated your DCC.</p>'
            }
            // domestic only is a non existing scenario for vaccination
        },
        'printTest': {
            'both': {
                'pageHeader': 'Print jouw bewijzen',
                'pageIntro': '<p><b>Jouw bewijzen</b><br>Je hebt een testbewijs gemaakt, in de vorm van een QR-code. Je hebt nu twee QR-codes: één voor Nederland en één internationale.</p><p><b>Informatie in de QR</b><br><a href="https://coronacheck.nl/nl/faq/1-6-welke-informatie-staat-in-mijn-qr-code/" target="_blank">Hier</a> kun je lezen wat er in de QR-codes staat.</p><p><b>Hoe gebruik ik het</b><br>Download/Print de PDF en neem het mee naar de locatie of activiteit die je bezoekt. Of naar het land waar je heen reist.</p><p>Let op: dit papieren bewijs is 1 jaar geldig. Daarna kan je een nieuw papieren bewijs maken van je vaccinatie.</p>'
            },
            'european': {
                'pageHeader': 'Print jouw internationale vaccinatiebewijs',
                'pageIntro': '<p><b>Jouw bewijs</b><br>Je hebt een internationaal vaccinatiebewijs gemaakt, in de vorm van een QR-code. Deze is alleen internationaal geldig, maar niet in Nederland.</p><p>Je hebt geen Nederlands vaccinatiebewijs. Dit kan bijvoorbeeld komen doordat je maar één prik hebt gehad. Voeg je tweede prik of een herstelbewijs toe om een bewijs te maken dat geldig is in Nederland.</p><p><b>Informatie in de QR</b><br><a href="https://coronacheck.nl/nl/faq/1-6-welke-informatie-staat-in-mijn-qr-code/" target="_blank">Hier</a> kun je lezen wat er in de QR-codes staat.</p><p><b>Hoe gebruik ik het</b><br>Print/Download de PDF en neem het mee naar de locatie of activiteit die je bezoekt. Of naar het land waar je heen reist.</p><p>Let op: dit papieren bewijs is 1 jaar geldig. Daarna kan je een nieuw papieren bewijs maken van je vaccinatie.</p>'
            },
            'local': {
                'pageHeader': 'Print your proof of test',
                'pageIntro': '<p><b>Your Proof</b><br>Je have made a laboratory proof of test (PCR or Antigen) as a QR code.</p><p><b>Information in the QR</b><br>You can check the content of the QR-Code <a href="https://coronacheck.nl/nl/faq/1-6-welke-informatie-staat-in-mijn-qr-code/" target="_blank">Hier</a>.</p><p><b>How do I use it</b><br>Print the PDF and take a copy with you to events or to the country you are travelling to.</p>'
            }
            // domestic only is a non existing scenario for vaccination
        },
        'printRecovery': {
            'both': {
                'pageHeader': 'Print your proof of recovery',
                'pageIntro': '<p><b>Your Proof</b><br>You’ve made a laboratory proof of test (PCR or Antigen) as a QR code.</p><p><b>Information in the QR</b><br>You can check the content of the QR-Code <a href="https://coronacheck.nl/en/faq/1-6-welke-informatie-staat-in-mijn-qr-code/" target="_blank">here</a>.</p><p><b>How do I use it</b><br>Print the PDF and take a copy with you to events or to the country you are travelling to.</p>'
            },
            'european': {
                'pageHeader': 'Print your proof of recovery',
                'pageIntro': '<p><b>Jouw bewijs</b><br>Je hebt een internationaal vaccinatiebewijs gemaakt, in de vorm van een QR-code. Deze is alleen internationaal geldig, maar niet in Nederland.</p><p>Je hebt geen Nederlands vaccinatiebewijs. Dit kan bijvoorbeeld komen doordat je maar één prik hebt gehad. Voeg je tweede prik of een herstelbewijs toe om een bewijs te maken dat geldig is in Nederland.</p><p><b>Informatie in de QR</b><br><a href="https://coronacheck.nl/nl/faq/1-6-welke-informatie-staat-in-mijn-qr-code/" target="_blank">Hier</a> kun je lezen wat er in de QR-codes staat.</p><p><b>Hoe gebruik ik het</b><br>Print/Download de PDF en neem het mee naar de locatie of activiteit die je bezoekt. Of naar het land waar je heen reist.</p><p>Let op: dit papieren bewijs is 1 jaar geldig. Daarna kan je een nieuw papieren bewijs maken van je vaccinatie.</p>'
            },
            'local': {
                'pageHeader': 'Print your proof of recovery',
                'pageIntro': '<p><b>Your Proof</b><br>You’ve made a laboratory proof of test (PCR or Antigen) as a QR code.</p><p><b>Information in the QR</b><br>You can check the content of the QR-Code <a href="https://coronacheck.nl/en/faq/1-6-welke-informatie-staat-in-mijn-qr-code/" target="_blank">here</a>.</p><p><b>How do I use it</b><br>Print the PDF and take a copy with you to events or to the country you are travelling to.</p>'
            }
            // european only and domestic only is a non existing scenario for recovery
        },
        'HomeAanmelding': {
            'pageHeader': 'Information about what you need to do',
            'pageIntro': '<h2 class="screen-reader-text">This is how it works</h2><p>U moet zich aanmelden om een Vaccinatie en Corona Test Resultaat Token te krijgen. Dit is hoe het werkt:</p><div class="home__section"><h4>Vaccinatie en Test Resultat Token aanvragen</h4><p>Jouw gezondheid en die van anderen is belangrijk. Daarom vragen sommige landen of plekken om een coronabewijs. Alleen met dit bewijs krijg je toegang. Je kan een coronabewijs maken als je bent gevaccineerd, als uit een test blijkt dat je geen corona hebt of als je corona hebt gehad en bent hersteld.</p></div><div class="home__section"><h4>QR-code = jouw bewijs</h4><p>Van jouw testuitslag of vaccinatie wordt een QR-code gemaakt. Dat is jouw bewijs. De QR-code wordt gecheckt bij de ingang van plekken en activiteiten. Of aan de grens.</p></div><div class="home__section"></div>'
        },
        'InformationAanmelding': {
            'pageHeader': 'Send your information',
            'pageIntro': '',
            'day': 'Day',
            'month': 'Month',
            'year': 'Year',
            'idcard': 'ID number',
            'driverslicense': 'Drivers License',
            'passport': 'Passport'
        },
        'VerificationAanmelding': {
            'pageHeader': 'You are almost there. Check your mailbox for your verification code.',
            'pageIntro': 'This verification code is valid for 30 minutes. Fill it in right away. It was sent to this %{contacttype}:',
            'enterverificationCode': 'Enter the Verification Code',
            'advice': 'We also advise to check your spam/junk folder.'
        },
        'SuccessAanmelding': {
            'pageHeader': 'Your request has been submitted.',
            'pageIntro': '',
            'description': '<p>Your request has been officially submitted and will be verified.<p> <p>If all information is correct, you will receive your unique combination code to activate your Digital Covid Certificate. You will receive your unique combination code via this email address.</p> <p>This process can take 48 hours, depending on how busy it is. We count on your understanding.</p>'
        }
    },
    'components': {
        'languagePicker': {
            'language': 'Language',
            'changeLanguage': 'Change language',
            'currentLanguage': 'Current language'
        },
        'faq': {
            'viewFaq': 'View frequently asked questions',
            'faqlink': '{host}/faqEN'
        },
        'preferMobile': {
            'header': 'Prefer having your certificate on mobile?',
            'intro': 'Then download the app. You can also make a print of the certificate in the app.'
        },
        'NegativeTest': {
            'resultNegative': 'Negative test result',
            'yourCredentials': 'Identification details'
        },
        'vaccination': {
            'vaccination': 'Vaccination',
            'name': 'Name',
            'dateOfBirth': 'Date of birth'
        },
        'recovery': {
            'title': 'Recovery certificate'
        },
        'positiveTest': {
            'title': 'Positive test result'
        },
        'proofEvent': {
            'name': 'Name',
            'dateOfTest': 'Test date',
            'dateOfBirth': 'Date of birth'
        },
        'digid': {
            'loginDigid': 'Log in with DigiD',
            'dontHaveDigid': 'I don’t have DigiD',
            'proofType': {
                'negativetest': 'test result',
                'vaccination': 'vaccinations',
                'positivetest': 'test result'
            }
        },
        'token': {
            'getToken': 'Retrieve data',
            'dontHaveVaccine': 'I have not been vaccinated.',
            'dontHaveToken': 'I do not have a unique combination code.',
            'proofType': {
                'negativetest': 'testuitslag',
                'vaccination': 'vaccinaties',
                'positivetest': 'testuitslag'
            }
        },
        'verificationcode': {
            'verifycode': 'Verify Code',
            'resendverificationcode': 'Click here to resend your verification code'
        },
        'AanmeldingInformation': {
            'preface': 'You are now going to sign up for a digital COVID-19 certificate. For this it is important that you enter the correct information about your first vaccination. Make sure you have your vaccination booklet at reach.',
            'idtype': 'SELECT THE IDENTITY TYPE YOU USED AT YOUR FIRST VACCINATION APPOINTMENT',
            'idnumber': 'ENTER YOUR IDENTITY NUMBER, FOR EXAMPLE: YYYYMMDDNR only numbers',
            'passport': 'Enter your passport number',
            'idnumberrp': 'Voer dat identiteitsnummer in',
            'phonenumber': 'ENTER YOUR PHONE NUMBER',
            'email': 'ENTER YOUR EMAIL ADDRESS',
            'contactMethod': 'Choose a contact method',
            'batchnumber': 'Enter first vaccination batch number',
            'locationfirstvaccination': 'Select location of first vaccination',
            'datefirstvaccination': 'Enter date of first vaccination (DD-MM-YYYY)',
            'personalInfoTitle': 'CONTACT INFORMATION',
            'firstvaccinationInfoTitle': 'FIRST VACCINATION INFORMATION',
            'consent': 'I HEREBY CERTIFY THAT THE INFORMATION GIVEN BY ME IN THIS APPLICATION IS TRUE AND CORRECT TO THE BEST OF MY KNOWLEDGE.'
        }
    },
    'message': {
        'info': {
            'testResultAbout': {
                'head': 'What has been retrieved?',
                'bodyV2': negativeTestV2,
                'bodyV3': negativeTestV3
            },
            'vaccinationAbout': {
                'head': 'What has been retrieved?',
                'body': vaccination
            },
            'recoveryAbout': {
                'head': 'What has been retrieved?',
                'body': recovery
            },
            'positiveTestResultAbout': {
                'head': 'What has been retrieved?',
                'body': positiveTest
            },
            'somethingWrong': {
                'vaccination': {
                    'head': 'Something is wrong',
                    'body': '<p>Wrong name or date of birth? Or are your vaccination details incorrect? Please go to <a href="https://www.coronacheck.nl/en/guidepost" target="_blank">CoronaCheck.nl/en/guidepost</a> for more information.</p>'
                },
                'negativetest': {
                    'head': 'Something is wrong',
                    'body': '<p>Do your details not match your ID? Please contact your test location to have your details adjusted.</p>'
                },
                'positivetest': {
                    'head': 'Something is wrong',
                    'body': '<p>Do your details not match your ID? Please contact your test location to have your details adjusted.</p>'
                }
            },
            'noVerificationCode': {
                'head': 'Need a new verification code?',
                'body': '<p>The test location sends you a verification code via text or email. Didn\'t get one? Then you can request a new code.</p>'
            },
            'didNotGetTestedYet': {
                'head': 'I haven’t been tested yet',
                'body': '<p>You must get tested before you make a QR-code. You can only turn a negative test result into a QR-code.</p><p>A test certificate is valid until 40 hours after the moment you’ve been tested. So schedule your test on time. And make sure your QR-code is scanned at the entrance within 40 hours.</p><p><a href="https://coronacheck.nl/en/testafspraak-in-app" class="btn" target="_blank">Make an appointment\n</a></p>'
            },
            'areYouSureToCancel': {
                'head': 'Are you sure you want to stop?',
                'body': 'Then you need to log in again later using DigiD to retrieve your %{type}.',
                'yes': 'Yes, stop',
                'no': 'No, continue'
            },
            'digidCanceled': {
                'head': 'Login failed',
                'body': 'You can log in again to retrieve your %{type}',
                'vaccination': 'vaccinations',
                'negativetest': 'test result',
                'positivetest': 'test result'
            },
            'digidFinished': {
                'body': 'We\'ll retrieve your %{type}. You will be logged out of DigiD automatically'
            },
            'resendverificationCode': {
                'head': 'Resend Verification Code',
                'body': 'A verification code was successfully resent to your %{contacttype}'
            }
        },
        'error': {
            'expiredTestCode': {
                'head': 'Your QR-code has expired',
                'body': '<p>The code you\'ve entered is invalid. Please check it again. Need a new QR-code? Get tested again.</p>'
            },
            'general': {
                'head': 'Sorry, something went wrong',
                'body': '<p>Because of a technical error. Contact the Curaçao Health App helpdesk.</p>'
            },
            'generalWithError': {
                'head': 'Sorry, there is an outage',
                'body': '<p>Contact our helpdesk and give them error code (%{code}) or try again later.</p>'
            },
            'serverBusy': {
                'head': '',
                'body': '<p>It\'s very busy at the moment. Try again later today.</p>'
            },
            'someServerBusyButResult': {
                'head': '',
                'body': '<p>Details possibly incomplete. Due to a technical issue at one of our involved parties, details might be missing. Please try again later./p>'
            },
            'someServerBusyNoResult': {
                'head': 'Sorry, it\'s very busy at the moment',
                'body': '<p>We can\'t retrieve your vaccinations now. Please try again later.</p>'
            },
            'someServerErrorButResult': {
                'head': '',
                'body': '<p>Something went wrong at one of our involved parties. Please try again if you\'re missing vaccinations.</p>'
            },
            'someServerErrorNoResult': {
                'head': '',
                'body': '<p>We can\'t retrieve your vaccinations now. Something went wrong at one of our involved parties. Please try again later.</p>'
            },
            'parseErrorInResult': {
                'head': '',
                'body': '<p>Something went wrong. The result could not be read. Please contact your event provider. (Code: x)</p>'
            },
            'noInternet': {
                'head': 'You\'re not connected to the internet',
                'body': 'Check your connection and try again.'
            },
            'signerFailed': {
                'head': 'Sorry, something went wrong',
                'body': '<p>Contact our helpdesk and give them error code (print sign error) or try again later.</p>'
            },
            'invalidToken': {
                'head': 'Sorry something went wrong',
                'body': 'Invalid Token. An example of a valid Token is: GMN-1234567891-V3'
            },
            'invalidTokenTest': {
                'head': 'Sorry something went wrong',
                'body': 'Invalid Token. An example of a valid Token is: 323776566'
            },
            'invalidTokenRecovery': {
                'head': 'Sorry something went wrong',
                'body': 'Invalid Token. An example of a valid Token is: 323776566'
            },
            'tokenNotFound': {
                'head': 'Sorry something went wrong',
                'body': 'token not found. %{code}'
            },
            'invalidVerificationCode': {
                'head': 'Sorry something went wrong',
                'body': 'Invalid verification code. Verification code is invalid or expired. %{code}'
            },
            'providerInfoNotFound': {
                'head': 'Sorry something went wrong',
                'body': 'Information not found.'
            },
            'AanmeldingInformation': {
                'InvalidIDNumber': 'Invalid ID Number',
                'InvalidEmail': 'Invalid Email Address',
                'InvalidVaccinatieDate': 'Invalid first vaccination Date',
                'InvalidVaccinatieDateFuture': 'Invalid first vaccination Date. Date cannot be in the future.',
                'selectIDType': 'Select a valid ID Type'
            },
            'InvalidVaccinatieDateDays': {
                'head': 'Sorry, something went wrong',
                'body': 'Invalid vaccination date. Select the correct date.'
            }

        }
    },
    'pdf': {
        'metadata': {
            'title': 'Certificate containing QR-code',
            'author': 'CoronaCheck'
        }
    },
    'back': 'Back',
    'close': 'Close',
    'faq': 'Frequently asked questions',
    'forInstanceAbbr': 'E.g.',
    'goBackToStart': 'To Home',
    'header-appstore': 'Download on the App Store',
    'header-googleplaystore': 'Get it on Google Play',
    'identity_image_alt': 'Make Holder QR-code',
    'logo-government': 'Logo Dutch Government, homepage',
    'next': 'Next',
    'of': 'of',
    'skiplink': 'Skip to content',
    'somethingIsWrong': 'Is something wrong?',
    'unknown': 'Unknown',
    'tooBusy': 'It\'s very busy right now, and therefore you cannot log in at the moment. Could you please try again later?',
    'onemoment': 'One moment please',
    'year': 'Year',
    'month': 'Month',
    'day': 'Day',
    'idtype': 'Identity type',
    'country': 'Country',
    'telephonenumber': 'Telephone number',
    'example': 'Example',
    'notfound': 'Not Found',
    'Retrievalcode': 'Retrieval code:',
    'emailadres': 'email address',
    'phonenumber': 'phone number',
    'Verificationcode': 'Verification code:'
}

export default en;
